import React from 'react'

export default class FlavorForm extends React.Component {
    constructor(props) {
      super(props);
      this.state = {value: 'Operador'};
  
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }
  
    handleChange(event) {
      this.setState({value: event.target.value});
    }
  
    handleSubmit(event) {
      alert('O seu cargo é: ' + this.state.value);
      event.preventDefault();
    }
  
    render() {
      return (
        <form onSubmit={this.handleSubmit}>
          <label>
            Que cargo está a concorrer:
            <select value={this.state.value} onChange={this.handleChange}>
              <option value="Operador">Operador</option>
              <option value="Secretaria">Secretaria</option>
              <option value="Engenharia">Engenharia</option>
              <option value="Logística">Logística</option>
            </select>
          </label>
          <input type="submit" value="Submit" />
        </form>
      );
    }
  }